module.exports = __webpack_public_path__ + "img/fn-sepr-flower.077a3c70.png";